import React from 'react';

var SvgWandIcon = function SvgWandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.165 3.893c-.784-.804-2.077-.804-2.862 0l-8.238 8.438c-.759.777-.759 2.018 0 2.795l.725.742c.778.798 2.06.804 2.847.015l4.082-4.092.006-.006 4.208-4.312c.759-.777.759-2.017 0-2.794l-.768-.786Zm-1.788 1.047c.196-.2.519-.2.715 0l.768.787c.19.194.19.504 0 .699l-1.048 1.073-1.484-1.484 1.049-1.075Zm-2.097 2.148-6.142 6.291c-.19.194-.19.505 0 .699l.725.742c.195.2.515.201.712.004l4.079-4.09 2.11-2.162-1.484-1.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12c.413 0 .75.336.75.75v.75h.75c.413 0 .75.336.75.75 0 .415-.337.75-.75.75h-.75v.75c0 .415-.337.75-.75.75-.415 0-.75-.335-.75-.75v-.75h-.75c-.415 0-.75-.335-.75-.75 0-.414.335-.75.75-.75h.75v-.75c0-.414.335-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.5c.413 0 .75.336.75.75v.75h.75c.413 0 .75.336.75.75s-.337.75-.75.75h-.75v.75c0 .414-.337.75-.75.75-.415 0-.75-.336-.75-.75v-.75h-.75c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h.75v-.75c0-.414.335-.75.75-.75Z"
  }));
};
SvgWandIcon.displayName = "WandIcon";

export { SvgWandIcon as S };
